import matchesActiveIf from 'Pods/ThreeDStudio/Hooks/matchesActiveIf'
import { MODEL_SOURCES } from 'Pods/ThreeDStudio/Services/Constants/modelSources'
import { threeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setAvailableGenerationProviders } from 'Pods/ThreeDStudio/Store/actions/schema'

/**
 * Resolves the model schema that should drive the generation form, based on the
 * current action and model settings. As a side effect, syncs the store's
 * `availableGenerationProviders` (and possibly `generationProvider`) so that
 * the AI Engine selector reflects the providers eligible for this action.
 *
 * @param {string} generationAction - Current generation action (e.g. "image-to-3d").
 * @param {Object} modelSettings - Current model settings used to evaluate each
 *   schema's `active_if` constraints.
 * @returns {Object|undefined} The eligible schema for the active generation
 *   provider, or undefined when no schema matches.
 */
const eligibleGenerationSchemas = (generationAction, modelSettings) => MODEL_SOURCES
  .filter(model => model.action === generationAction)
  .filter(schema => matchesActiveIf(schema, modelSettings))

/**
 * Resolves the schema a given provider would run for the action and settings, with no
 * store side effects. Used when the provider is not active yet, e.g. to match the use
 * case against the engine about to be picked.
 *
 * @param {string} generationAction - Generation action (e.g. "image-to-3d").
 * @param {Object} modelSettings - Model settings used to evaluate `active_if`.
 * @param {string} provider - Provider id.
 * @returns {Object|undefined} The eligible schema, or undefined when none matches.
 */
export const getGenerationSchemaForProvider = (generationAction, modelSettings, provider) => (
  eligibleGenerationSchemas(generationAction, modelSettings).find(schema => schema.provider === provider)
)

export const getNextGenerationSchema = (generationAction, modelSettings) => {
  const eligible = eligibleGenerationSchemas(generationAction, modelSettings)
  const providers = [...new Set(eligible.map(schema => schema.provider))]
  setAvailableGenerationProviders(providers)
  const activeProvider = threeDStudioStore.getState().schema.generationProvider

  return eligible.find(schema => schema.provider === activeProvider)
}
